import { Link } from "react-router-dom";
import { ArrowRight, Quote, Star } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { testimonials } from "@/data/content";
import { useSiteContent } from "@/i18n/SiteContentContext";

export const TestimonialCard = ({ t, index }) => (
  <div data-testid={`testimonial-card-${index}`} className="hex-card group h-full border border-royal/15 bg-gradient-to-b from-ice/90 to-white p-8 shadow-xl shadow-royal/10 backdrop-blur-xl transition-all duration-300 hover:-translate-y-2 hover:border-gold/50 hover:shadow-2xl hover:shadow-gold/20">
    <Quote className="h-8 w-8 text-gold" />
    <p className="mt-4 text-sm leading-relaxed text-royal/80 md:text-base">"{t.text}"</p>
    <div className="mt-6 flex items-center justify-between border-t border-royal/10 pt-5">
      <div>
        <p className="font-jakarta text-sm font-bold text-navy">{t.name}</p>
        <p className="text-xs text-royal/60">{t.role}</p>
      </div>
      <div className="flex gap-0.5">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="h-3.5 w-3.5 fill-gold text-gold" />
        ))}
      </div>
    </div>
  </div>
);

export const TestimonialsPreview = () => {
  const { get } = useSiteContent();
  const testimonialList = get("testimonials", testimonials);
  return (
  <section id="testimonials" data-testid="testimonials-preview-section" className="honeycomb-bg relative overflow-hidden bg-gradient-to-b from-white via-ice/40 to-white py-28 md:py-40">
    <div className="pointer-events-none absolute -left-32 top-32 h-80 w-80 rounded-full bg-gold/10 blur-3xl" />
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading
        number="07"
        eyebrow="Client Voices"
        title={<>Word travels <span className="text-royal/40">faster than freight.</span></>}
      />
      <div className="grid gap-8 md:grid-cols-3">
        {testimonialList.slice(0, 3).map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <TestimonialCard t={t} index={i} />
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-16 text-center">
        <Link to="/testimonials" data-testid="testimonials-view-all-btn" className="btn-outline-premium">
          View All Testimonials <ArrowRight className="h-4 w-4" />
        </Link>
      </Reveal>
    </div>
  </section>
  );
};